import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import LoadingSpinner from "../../components/LoadingSpinner";
export default function Subscriptions() {
  const [mySubsciptions, setMySubscriptions] = useState([])

  const [isLoading, setIsLoading] = useState(false);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const fetchData = async () => {
    try {
      setIsLoading(true);

      // const overduesubResponse = await axios.get(
      //   `${ApiConnectionString}/Stripe/subscriptions?AppUserId=${user.id}&Overdue=true`,
      //   {
      //     headers: { Authorization: `Bearer ${user.token}` },
      //   }
      // );
      // setOverdueSubs(overduesubResponse.data);

      // Fetch subscriptions data
      const subResponse = await axios.get(
        `${ApiConnectionString}/api/MySubscriptions`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setMySubscriptions(subResponse.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);
  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        {" "}
        <div className="lightBlueBanner mt-2">
          <p className="text-white p-2 mx-3 fw-bold ">List of Subscritions</p>
        </div>
        {mySubsciptions.map((sub) => (
  <div
    onClick={() => navi(`/MyOneSubscription/${sub.id}`)}
    key={sub.id}
    className="your-classes-container p-3 mx-3 my-1 rounded shadow position-relative"
  >
    {sub.cancelPending && (
      <span className="badge bg-warning position-absolute top-0 end-0 m-2">
        Cancel Pending
      </span>
    )}

    <div className="row align-items-center">
      <div className="col-6 text-center">
        <p className="my-0 p-0 mx-5 fw-bold">{sub.productName}</p>
        <div className="circle-crop">
          <img
            src={
              sub.viewClubs.hasImage
                ? `${ApiConnectionString}/api/ClubProfileImage/${sub.clubId}`
                : NoImagePlaceholder
            }
            alt="Club Image"
            className="mt-0"
          />
        </div>
      </div>

      <div className="col">
        <div className="d-flex">
          <div className="">
            <p className="red-text mb-0">Club</p>
            <p className="fw-bold">{sub.viewClubs.name}</p>
          </div>

          <div className="mx-3">
            <p className="red-text mb-0">Profile</p>
            <p className="fw-bold">{sub.username}</p>
          </div>

          <div className="">
            <p className="red-text mb-0">Member Since</p>
            {sub.created && <p className="fw-bold">{sub.created.substring(0, 10)}</p>}
          </div>
        </div>
      </div>
    </div>
  </div>
))}


      </div>
    );
  }
}
